import { BaseEntity } from './base-entity.model';

export class Feedback extends BaseEntity<Feedback> {
  message = '';
  rating = 4;
  reason = 'GENERAL';
}
